import { combineReducers } from 'redux'
import {
  createReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizeGroups = data => {
  const group = new schema.Entity('groups')
  return normalize(data, [group])
}

const GroupsReducer = combineReducers({
  fetching: createRequestReducer('GROUPS_STORE:FETCHING', { pending: true }),
  data: createReducer(
    { groups: null, categories: null },
    {
      'GROUPS_STORE:FETCHING_REQUEST_SUCCESS': (state, { response }) => ({
        ...state,
        groups: normalizeGroups(response.data.school.groups),
        categories: response.data.school.group_categories
      })
    }
  )
})

export default GroupsReducer
